import Message from "./Message";

export default {
  install(Vue) {
    Vue.prototype.$message = Message;
  },
};



// WEBPACK FOOTER //
// ./src/components/message/index.js